/** The sanitized-JSON block the simulator shows in technical details. */
export const preStyle = {
  margin: 0,
  maxHeight: 256,
  overflow: "auto",
  padding: "12px 14px",
  borderRadius: "var(--rd-radius-lg)",
  background: "var(--rd-surface-soft)",
  boxShadow: "inset 0 0 0 1px var(--rd-line-header)",
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
  fontSize: 12,
  lineHeight: 1.55,
  whiteSpace: "pre-wrap",
  overflowWrap: "anywhere",
  textAlign: "start",
} as const;
